import { all } from 'redux-saga/effects';

import auth from '@giro/shared-store/auth';

import router from '@giro/shared-store/router';

import pdv from '@giro-pdv/modules/pdv/store';
import login from '@giro-pdv/modules/login/store';
import reports from '@giro-pdv/modules/reports/store';
import receipt from '@giro-pdv/modules/receipt/store';
import monitoring from '@giro-pdv/modules/monitoring/store';
import slip from '@giro-pdv/modules/slips/store';

import dialogReceipt from './dialogReceipt';
import menu from './menu';

function* rootSaga() {
  yield all([
    router.saga.watch(),
    monitoring.saga.watch(),
    pdv.saga.watch(),
    receipt.saga.watch(),
    reports.saga.watch(),
    login.saga.watch(),
    auth.saga.watch(),
    dialogReceipt.saga.watch(),
    menu.saga.watch(),
    slip.saga.watch(),
  ]);
}

export default rootSaga;
